























import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
@Component({})
export default class Breadcrumb extends Vue {
  private bread = '';
  private path = '';
  @Watch('$route')
  reloadBread() {
    const title = this.$route.meta.title;
    this.bread = title.split('/');
    this.path = this.$route.matched[0].path;
  }
  mounted() {
    this.reloadBread()
  }
  /**
   * 是否能返回上一页
   * @return: Boolean
   */
  get canBack() {
    return !this.$route.path.includes('dashboard');
  }
  private goBack() {
    this.$router.back();
  }
}
